import React from 'react';
import { ISbgListAvailableProps, ListPageDetailViewModel } from '../SbgFilterList.types';

export class SbgListAvailable extends React.Component<ISbgListAvailableProps> {
  constructor(props: ISbgListAvailableProps) {
    super(props);
  }

  renderButton = (item: ListPageDetailViewModel) => {
    if (
      this.props.availableModel.renderApplyButton &&
      item.shouldRenderApplyButton &&
      item.formExternalUrl &&
      item.formExternalUrl !== ''
    ) {
      if (this.props.availableModel.canStartApplication) {
        return (
          <a className="button" href={item.formExternalUrl}>
            Ansök nu
          </a>
        );
      } else {
        return <span className="button button--disabled">Ansök nu</span>;
      }
    }
  };

  renderAvailableItem = (item: ListPageDetailViewModel) => {
    return (
      <div key={item.sbgApplicationDetailsPage.sbgPageName} className="datelist-item">
        <div className="datelist-item__datewrap">
          <div className="small-text">Ansök senast</div>
          <div className="datelist-item__date">
            <div>{item.sbgApplicationDetailsPage.lastApplicationDayMonth}</div>
            <div> {item.sbgApplicationDetailsPage.lastApplicationYear}</div>
          </div>
        </div>
        <div className="datelist-item__body datelist-item__body--split">
          <div className="datelist-item__innerbody">
            <h3>
              <a className="external-link" target="_blank" href={item.sbgApplicationDetailsPage.sbgPageUrl}>
                {item.sbgApplicationDetailsPage.sbgPageName}
              </a>
            </h3>
            <div className={`small-text ${item.sbgApplicationDetailsPage.remainingDayCssClass}`} tabIndex={0}>
              {item.sbgApplicationDetailsPage.remainingTime}
            </div>
          </div>
          <div className="datelist-item__innerbody">{this.renderButton(item)}</div>
        </div>
      </div>
    );
  };

  render() {
    const { availableModel, hideHeading, isAuthenticated, loginButtonUrl } = this.props;
    return (
      <>
        {!hideHeading && <h2>Öppna för ansökan</h2>}
        {availableModel &&
          availableModel.openForApplication &&
          availableModel.openForApplication.map((x) => this.renderAvailableItem(x))}
        {!isAuthenticated && loginButtonUrl && (
          <a className="button" href={loginButtonUrl}>
            Logga in för att ansöka
          </a>
        )}
      </>
    );
  }
}
